<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
*,
*:before,
*:after {
  box-sizing: border-box;
}

@font-face {
  font-family: 'Roboto';
  src: local('Roboto'),
    url(~@/assets/fonts/Roboto-Regular.ttf) format('truetype');
}

input:focus,
select:focus,
textarea:focus,
button:focus {
  outline: none;
}

input[type='text'] {
  width: 100%;
  padding: 10px 0px;
  border-width: 0 0 2px;
  border-color: grey;
  font-size: 20px;
}

input[type='password'] {
  width: 100%;
  padding: 10px 0px;
  border-width: 0 0 2px;
  border-color: grey;
  font-size: 20px;
}

input:focus {
  border-color: #7dc355;
}

ul {
  padding: 0;
  margin: 5px 0px;
  list-style-type: none;
}

button {
  /* remove default behavior */
  appearance: none;
  -webkit-appearance: none;

  /* usual styles */
  margin-top: 20px;
  padding: 15px;
  border: none;
  background-color: #7dc355;
  color: #fff;
  font-weight: 600;
  border-radius: 5px;
  width: 100%;
  cursor: pointer;
}

body {
  margin: 0;
}

.wrapper {
}

#nav {
  align-content: center;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
